// StringHelpers.js
export const FullAlphabet = [
    'a', 'b', 'c', 'd', 'e',
    'f', 'g', 'h', '*', 'i', // * == ch
    'j', 'k', 'l', 'm', 'n',
    'o', 'p', 'q', 'r', 's',
    't', 'u', 'v', 'w', 'x',
    'y', 'z'
]
export const EngAlphabet = [
    'a', 'b', 'c', 'd', 'e',
    'f', 'g', 'h', 'i', 'j',
    'k', 'l', 'm', 'n', 'o',
    'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z'
]

export function getAlphabet(hasCh = false) {
    return (hasCh ? FullAlphabet : EngAlphabet);
}

export function rotateAlphabet(rot = 0, hasCh = false) {
    if (hasCh) {
        let mod = FullAlphabet.length;
        console.log(`rotated - ${rot}:${[...FullAlphabet.slice(rot % mod, FullAlphabet.length), ...FullAlphabet.slice(0, rot % mod)]}`)
        return [...FullAlphabet.slice(rot % mod, FullAlphabet.length), ...FullAlphabet.slice(0, rot % mod)]
    } else {
        let mod = EngAlphabet.length;
        console.log(`rotated - ${rot}:${[...EngAlphabet.slice(rot % mod, EngAlphabet.length), ...EngAlphabet.slice(0, rot % mod)]}`)
        return [...EngAlphabet.slice(rot % mod, EngAlphabet.length), ...EngAlphabet.slice(0, rot % mod)]
    }
}

export function keyedAlphabet(key, hasCh = false) {
    if(key=="" || key==null||key==undefined){
        return getAlphabet(hasCh);
    }
    return [...new Set([...(key.split('')), ...hasCh ? FullAlphabet : EngAlphabet])]
}

export function missingCharAlphabet(missing,hasCh){
    return (hasCh ? FullAlphabet : EngAlphabet).filter((str) => {
        return missing.every((a)=>{
            let c = a.toLowerCase();
            c = hasCh ? c.replace('ch', '*') : c;
            return str !== c
        })
    });
}

export function missingCharKeydAlphabet(key, missing,hasCh){
    if(key=="" || key==null||key==undefined){
        return missingCharAlphabet(missing, hasCh);
    }
    return keyedAlphabet(key, hasCh).filter((str) => {
        return missing.every((a)=>{
            let c = a.toLowerCase();
            c = hasCh ? c.replace('ch', '*') : c;
            return str !== c
        })
    });
}

export function removeDiacritics(string) {
    return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function capitalize(s){
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

export function clearString(string, replaceCh = true) {
    let cleaned = removeDiacritics(string).toLowerCase();
    if (replaceCh) {
        cleaned = cleaned.replace("ch", '*')
    }
    return cleaned.replaceAll("  ", ' ')
        .replaceAll(", ", '')
        .replaceAll(",", '')
        .replaceAll("..", '.')
        .replaceAll(". ", '.')
        .replaceAll(" . ", '.')
        .replaceAll(".  ", '.');
}

export function makeSpaceless(string) {
    return string.replaceAll(/[.,\-_=?! ]/g, '');
}

export default {
    removeDiacritics,
    clearString,
    getAlphabet,
    capitalize,
    rotateAlphabet,
    keyedAlphabet,
    makeSpaceless,
    EngAlphabet,
    FullAlphabet
};